import { useEffect } from 'react'
import { hasHrAccessToken } from 'services/session/authSession'

const Home = () => {
  const isAuth = hasHrAccessToken()

  useEffect(() => {
    if (isAuth) {
      window.location.href = '/app'
    } else {
      window.location.href = process.env.REACT_APP_ADNEXIO_NEXT_URL + `/hrms`
    }
  })

  return null

  // return <LandingPage />
}

export default Home
